import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import useStrengthModal from '../../../hooks/useStrengthModal';

const OpenStrengthModalOnHash = ({ children }) => {
    const history = useHistory();
    const { openStrengthModal } = useStrengthModal();
    useEffect(() => {
        const { hash } = history.location;
        if (!hash) return;

        openStrengthModal(hash.substring(1));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.hash]);

    return children;
};

OpenStrengthModalOnHash.propTypes = {
    children: PropTypes.element,
};

export default OpenStrengthModalOnHash;
